import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import Header from "./header/Header";
import Body from "./body/Body";
import NotEnteredAnswerPopup from "../../learning/presentational/popup/NotEnteredAnswerPopup";

const AnsweringQuestions = ( props ) => {

  const answeringQuestions = useSelector( state => state.answeringQuestions );

  const {
    NotEnteredAnswerChecker,
    children,
    ...PROPS
  } = props;

  return (
    <div className="layout-def layout-learning gm">
      <Header { ...PROPS } />
      <Body { ...PROPS } />
      { answeringQuestions.isShowNotEnteredAnswerPopup && <NotEnteredAnswerChecker><NotEnteredAnswerPopup /></NotEnteredAnswerChecker> }
    </div>
  );

};

AnsweringQuestions.defaultProps = {
  NotEnteredAnswerChecker : Fragment
};

export default AnsweringQuestions;
